import {
  Container as ChakraContainer,
  type ContainerProps,
} from "@chakra-ui/react";

type IProps = ContainerProps;

const Container = ({ children, maxW, ...props }: IProps) => {
  return (
    <ChakraContainer
      display="flex"
      flexDirection="column"
      gap={10}
      px={{ base: 3, md: 4 }}
      maxW={maxW}
      mx="auto"
      {...props}
    >
      {children}
    </ChakraContainer>
  );
};

export { Container };
